import PageContainer from "../../../../components/container/PageContainer";

export default function DashboardAdmin() {
    return (
        <PageContainer menuTitle="Dashboard">
            <h1>Dashboard</h1>
        </PageContainer>

    );
}